<template>
    <div class="sh040" id="sh040">
        <loading :active.sync="isLoading" 
            :can-cancel="false"
            :background-color="'transparent'">
        </loading>
        <!-- ご注文手続き -->
        <div class="sh040-title">
            <h2>{{$t("sh030.labels.orderProcedure")}}</h2>
        </div>

        <div class="section-inner sh040-body">
            <!--お届け先選択タイトル-->
            <div class="sh040-body-title">
                <h4>お届け先の選択</h4>
                <span id="tdkCopyMsg"></span>
            </div>
            
            <div class="sh040MainArea">
                <div class="sh040MainAreaRow">
                    <template v-for="(item, index) in sh040Init.multTdksInfo"  >
                        <!-- お届け先情報 -->
                        <div class="sh040MainAreaRowOfOne" v-bind:key="index" >
                            <div class="sh040MainAreaRowOfOneCard">
                                    <div class="sh040MainAreaRowOfOneCardHead" >
                                        <div class="sh040MainAreaRowOfOneCardHeadTitle">
                                            <span v-if="item.TDK_M_SEQ ==0 && sh040Init.siteFlg == 0" class="h3 bg-primary text-white">本人</span>
                                            <span v-else-if="item.TDK_M_SEQ ==0 && sh040Init.siteFlg == 1" class="h3 bg-primary text-white">自社</span>
                                        </div>
                                        <div class="sh040MainAreaRowOfOneCardHeadCheck1">
                                            <input type="checkbox" :id="'tdkNoCheckBox' + index" name="tdkNoCheckBox" :true-value="item.TDK_M_SEQ" :false-value="-1" v-model="sh040ReqModel.tdkNoCheckBox[index]" @click="setTdkNoCheckBox(index)">
                                        </div>
                                    </div>
                                    <div class="sh040MainAreaRowOfOneCardBody" >
                                        <h5 class="sh040MainAreaRowOfOneCardBodyContents">{{item.TDK_NM1}}&nbsp;{{item.TDK_NM2}}&nbsp;{{item.TDK_NM3}}</h5>
                                        <h5 class="sh040MainAreaRowOfOneCardBodyContents">{{item.TDK_ZIP}}</h5>
                                        <h5 class="sh040MainAreaRowOfOneCardBodyContents">{{item.TDK_ADDR1}}{{item.TDK_ADDR2}}{{item.TDK_ADDR3}}</h5>
                                        <h5 class="sh040MainAreaRowOfOneCardBodyContents">{{item.TDK_TEL1}}</h5>
                                    </div>
                                    <div class="sh040MainAreaRowOfOneCardHead" v-if="sh040Init.seikyudoukonOption == 1 && sh040Init.siteSeikyudoukonOption == 1 " >
                                        <div class="sh040MainAreaRowOfOneCardHeadTitle"></div>
                                        <div class="sh040MainAreaRowOfOneCardHeadCheckBottom">
                                            <input type="hidden" :id="'seikyuDoukonFlgHidden'+index" v-model="sh040ReqModel.seikyuDoukonFlg[index]">
                                            <label :for="'seikyuDoukonFlg'+index" v-if="sh040ReqModel.tdkNoCheckBox[index] !== -1" >
                                                <input type="checkbox" :id="'seikyuDoukonFlg'+index" name="seikyuDoukonFlg" :true-value="1" :false-value="0" v-model="sh040ReqModel.seikyuDoukonFlg[index]" class="margin-left-10px" @click="setSeikyuDoukonFlg(index)">
                                                <span>{{$t("sh030.labels.seikyuDoukonFlg")}}</span>
                                            </label>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </template>
                    <!-- お届け先情報(追加) -->
                    <div class="sh040MainAreaRowOfOneAdd">
                        <div class="sh040MainAreaRowOfOneCardAdd">
                                <div class="sh040MainAreaRowOfOneCardBodyAdd" >
                                    <div >
                                    <a href="javascript:void(0)" @click="gotoTdkAddPage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="45px" height="45px" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                    <div id="tdkTuikaCopyMsg" class="sh040MainAreaRowOfOneCardBodyAddTitle">お届け先追加</div></a></div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
     
            <!--戻るボタン-->
            <div id="btn_roll2" >
                <a class="btnSubmit" @click="goBack()">{{$t('common.buttons.backtothepreviouspage')}}</a>
                &nbsp;
                <!-- 次へ進む / 変更 -->
                <a class="btnSubmit" @click="confirmTdkSelect()">
                    {{ sh040Init.stepBasedFlg == 1 ? $t("common.buttons.proceedNext") : $t("common.buttons.change") }}
                </a>
            </div>
        </div>
        <!-- modal confirm area -->
        <alert-confirm
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :isButtonCancel="false"
        >
        </alert-confirm>
    </div>
</template>

<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import common from 'assets/js/common';
import SiteConstants from 'assets/const/SiteConstants.json';
import AlertConfirm from 'components/AlertConfirm';
import EventBus from 'assets/js/eventBus';
import Loading from 'vue-loading-overlay';

export default {
    /*
    * Name of component
    */
    name: "SH040ShopperTdkInfoGift",
    /* 
    * Declare components
    */
    components: {
        AlertConfirm,
        EventBus,
        Loading
    },
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            isModalShow:false,
            msgConfirm:'',
            sh040ReqModel: {
                tdkNoCheckBox: [],
                seikyuDoukonFlg: [],
            },
            sh040Init: {},
            queryData: null,
            backPageNo: null,
            SiteConstants: SiteConstants,
            site: "",
            isLoading: false,
        }
    },
    /*
    * 初期処理
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            // 未ログインの場合はログイン画面へ
            if(_this.ptInitData.isLogin == false) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18, returnFlg:1, fromCart:1}});
            } else {
                _this.sh040Init = _this.ptInitData;
                // W_EA012.TDK_NO>0のレコードが存在するか（2回目以降の遷移かどうか）
                var hasMultiTdk = _this.sh040Init.multTdksInfo.some(function(item) {
                    return item.TDK_M_SEQ > 0 && item.TDK_PAGE_CHK !== -1;
                });
                for (var i = 0; i < _this.sh040Init.multTdksInfo.length ; i++ ) {
                    var info = _this.sh040Init.multTdksInfo[i];
                    // 複数届先指定画面でデフォルトチェックを外すオプション(50779)が有効かつ初回かつ自宅（TDK_M_SEQ=0）の場合はデフォルトチェックを外す
                    if (_this.sh040Init.tdkDefaultCheckOption == 1 && !hasMultiTdk && info.TDK_M_SEQ === 0) {
                        _this.sh040ReqModel.tdkNoCheckBox[i] = -1;
                    } else if (info.TDK_PAGE_CHK !== -1) {
                        _this.sh040ReqModel.tdkNoCheckBox[i] = info.TDK_M_SEQ;
                    } else {
                        _this.sh040ReqModel.tdkNoCheckBox[i] = -1;
                    }
                    _this.sh040ReqModel.seikyuDoukonFlg[i] = info.HARAIKOMI_DOUKON_FLG;
                }
            }
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH040 + _this.$UrlConstants.DO_INIT, _this.sh040ReqModel).then(function(response) {
                // 未ログインの場合はログイン画面へ
                if(response.data.isLogin == false) {
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                } else {
                    _this.sh040Init = response.data;
                    // W_EA012.TDK_NO>0のレコードが存在するか（2回目以降の遷移かどうか）
                    var hasMultiTdk = _this.sh040Init.multTdksInfo.some(function(item) {
                        return item.TDK_M_SEQ > 0 && item.TDK_PAGE_CHK !== -1;
                    });
                    for (var i = 0; i < _this.sh040Init.multTdksInfo.length ; i++ ) {
                        var info = _this.sh040Init.multTdksInfo[i];
                        // 複数届先指定画面でデフォルトチェックを外すオプション(50779)が有効かつ初回かつ自宅（TDK_M_SEQ=0）の場合はデフォルトチェックを外す
                        if (_this.sh040Init.tdkDefaultCheckOption == 1 && !hasMultiTdk && info.TDK_M_SEQ === 0) {
                            _this.sh040ReqModel.tdkNoCheckBox[i] = -1;//カート分割対応
                        } else if (info.TDK_PAGE_CHK !== -1) {
                            _this.sh040ReqModel.tdkNoCheckBox[i] = info.TDK_M_SEQ;//カート分割対応
                        } else {
                            _this.sh040ReqModel.tdkNoCheckBox[i] = -1;//カート分割対応
                        }
                    }
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }

        //POPUPを閉じる処理
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
        });
    },
    /*
    * Methods
    */
    methods: {
        gotoSettingPage : function(nextPageId) {
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: nextPageId}});
        },
        /*
        * お届け先追加ボタン押下処理
        */
        gotoTdkAddPage : function() {
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: 78}, params: {motoPageId: 'sh040'}});
        },
        setSeikyuDoukonFlg(index1) {
            this.sh040ReqModel.seikyuDoukonFlg = Array.from(Array($("input[name=tdkNoCheckBox]").length), () => 0);
            if ($( "#seikyuDoukonFlg" + index1 ).prop('checked')) {
                return;
            }
            $('input[name=seikyuDoukonFlg]').each(function(){
                $(this).prop('checked', false);
            });
        },
        setTdkNoCheckBox(index) {
            this.sh040ReqModel.seikyuDoukonFlg[index] = 0;
        },
        /*
        *  前のページへ戻るボタン押下処理
        */
        goBack: function() {
            var _this = this;
            var pageNo = _this.backPageNo || 16; // 戻り先ページNOが設定されていなければ、カート画面へ戻る
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: pageNo}, params:{motoPageId: 'sh040'}});
        },
        /*
        * お届け先選択確定処理
        */
        confirmTdkSelect: function() {
            var _this = this;
            const selectedCount = _this.sh040ReqModel.tdkNoCheckBox.filter(item => item !== -1).length;
            const isStepBased = _this.sh040Init.stepBasedFlg == 1;
            if ((!isStepBased && selectedCount === 0) || (isStepBased && selectedCount < 2)) {
                _this.msgConfirm = isStepBased
                    ? _this.$i18n.t('sh040.messages.tdkTwoOrMoreChecked')
                    : _this.$i18n.t('sh040.messages.tdkNoNotChecked');
                _this.isModalShow = true;
                return;
            }
            _this.$emit("event-loading", true);

            _this.sh040ReqModel.tdkMSeqs = Array.from(_this.sh040ReqModel.tdkNoCheckBox, (x) => (x == _this.sh040Init.multTdksInfo[0].TDK_M_SEQ) ? 0 : 1); 
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH040 + _this.$UrlConstants.DO_INSERT, _this.sh040ReqModel).then(function(response) {
                //PageNo:28 お届先振り分け設定画面へ
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 28, backPageNo: 20} , params:{motoPageId: 'sh060'}});
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error && error.response.status) {
                    var resultValid = common.excuteValidationEcSite(error);
                    if(resultValid) {
                        alert(resultValid.msgList);
                    }
                } else {
                    common.errorAPI(error);
                }
                common.scrollTop();
            });
        }
    },
    created(){
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.backPageNo != null){
                this.backPageNo = this.queryData.backPageNo;
            }
        }
    },
    beforeDestroy() {
        EventBus.$off('closed');
        EventBus.$off('is-loading');
    }
}
</script>
